import React, { useState, FC } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Divider, Grid, Button } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '@semi-configurator-messages'
import { semiConfigContext, ProductDetails } from '../Shrna'
import { priceFormatter } from '../../../../Configurators/utils/PriceFormatter'
import {
  SpecificationMessages,
  SemiConfigProperties,
  ActiveLinkType,
  ErrorMessage,
  Url,
  getPhysicalMaterialKey,
} from '../Enum'
import { useShrnaAddToCartMutation } from '@src/mutations/SemiconfigShrnaMutation.generated'
//import { QUICK_CART } from '../../../../../queries/QuickCartQuery'
import AddToCartItems from '@src/routes/Configurators/components/AddToCart/AddToCartItems'
import { loginRoute, useRouter } from '@src/routes'
import {
  SnackbarType,
  useGlobalSnackbar,
} from '@src/components/GlobalSnackbar/globalSnackBarContext'
import CircleLoader from '@src/components/CircleLoader'
import {
  handleGAAddToCartForConfigurator,
  handleGAAddToCartErrorsForConfigurator,
} from '@utils/analytics/configuratorAnalytics'
import {
  ProductNames,
  ConfiguratorValues,
} from '@src/routes/Configurators/utils/constants'
import { getSemiConfiguratorGAdata } from '@src/routes/SemiConfigurators/utils/util'
import styles from '@src/routes/SemiConfigurators/utils/styles'

const useStyles = makeStyles((theme: Theme) => ({
  contentWrapper: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(5),
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(5),
  },
  shipping: {
    fontWeight: 800,
    fontSize: theme.typography.pxToRem(12),
    paddingBottom: theme.spacing(3),
    paddingRight: theme.spacing(1),
  },
  shippingbody: {
    fontSize: theme.typography.pxToRem(12),
    bottomPadding: theme.spacing(3),
  },
  note: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(12),
    paddingBottom: theme.spacing(0),
    paddingRight: theme.spacing(1),
  },
  listContainer: {
    paddingLeft: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  list: {
    padding: theme.spacing(0, 0, 10, 0),
  },
  checkBox: {
    paddingTop: theme.spacing(0),
    paddingLeft: theme.spacing(3),
  },
  textStyle: {
    fontSize: theme.typography.pxToRem(14),
  },
  head: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightBold,
    margin: theme.spacing(0, 0, 5),
  },
  button: {
    marginTop: theme.spacing(0),
    minWidth: '100%',
  },
  listPadding: {
    fontSize: theme.typography.pxToRem(12),
  },
  subListPadding: {
    paddingBottom: theme.spacing(2),
  },
  subHead: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightMedium,
    margin: theme.spacing(3, 0, 4),
  },
  orderContainer: {
    paddingTop: theme.spacing(8),
    fontSize: theme.typography.pxToRem(12),
  },
  headingPadding: {
    marginTop: theme.spacing(-0.5),
    marginLeft: theme.spacing(-1),
  },
  physicalContainer: {
    marginTop: theme.spacing(0),
  },
  checkMargin: {
    marginLeft: theme.spacing(-4),
  },
  dividerHor: {
    marginTop: theme.spacing(-3),
  },
  leftPadding: {
    marginLeft: theme.spacing(7),
  },
  divider: {
    height: theme.spacing(30),
    marginTop: theme.spacing(16),
    marginLeft: theme.spacing(4),
    width: '2px',
  },
  paddingBott: {
    paddingBottom: theme.spacing(4),
  },
  subTotal: {
    fontSize: theme.typography.pxToRem(12),
  },
  subHeadPrice: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightMedium,
    margin: theme.spacing(3, 0, 4),
    textAlign: 'right',
  },
  fontQuote: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightBold,
  },
  marginBottom: {
    marginBottom: theme.spacing(5),
  },
}))
interface SemiConfigDetailsForGA {
  productDetails: any
  totalQuantity: number
  price: string
  productName: string
}
interface SummaryProps {
  onDelete: any
  productDetails: ProductDetails
  currencyFormat: string
  updateError: any
  thousandSeparator: any
  thousandSpacing: any
  prefixCurrecny: any
  decimalSeparator: any
}

const Summary: FC<SummaryProps> = (props) => {
  const classes = useStyles()
  const globalClasses = styles()
  const { state, dispatch } = React.useContext(semiConfigContext)
  const { priceCallResponse, priceCallData } = state
  const [price, setPrice] = useState<string>('')
  const intl = useIntl()
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [totalPrice, setTotalPrice] = useState<string>('')
  const [totalItem, setTotalItem] = useState<number>(0)
  const router = useRouter()
  const { setGlobalSnackbarState } = useGlobalSnackbar()
  const locale = props.productDetails.locale
  const {
    currencyFormat,
    thousandSeparator,
    thousandSpacing,
    prefixCurrecny,
    decimalSeparator,
  } = props

  React.useEffect(() => {
    const sapNextEnabled = props.productDetails.sapNextEnabled
    const timeZone = props.productDetails.timeZone
    const store = props.productDetails.store
    if (state.priceCallData.cloneInformation.length) {
      const crisprgrnaList = priceCallResponse.shrnaResult
      crisprgrnaList.forEach((sc) => {
        delete sc.__typename
      })

      dispatch({
        type: 'UPDATE_ADD_TO_CART_DATA',
        data: {
          ...state.priceCallData,
          cloneInformation: crisprgrnaList,
          sapNextEnabled,
          locale,
          timeZone,
          store,
        },
      })
      setTotalItem(state.priceCallData.cloneInformation.length)
    }

    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceCallResponse, priceCallData])

  const [shrnaAddToCart, { data, loading }] = useShrnaAddToCartMutation({
    // refetchQueries: [
    //   {
    //     query: QUICK_CART,
    //     variables: { id: CartRequestAction.Mini },
    //   },
    // ],
    // awaitRefetchQueries: true,
  })

  const calculatePrice = (): void => {
    let totalPrice = 0
    let isPriceValid = true
    priceCallResponse.shrnaResult.forEach((data) => {
      if (
        data.price &&
        data.price.toString() !== SpecificationMessages.quote &&
        data.price !== SpecificationMessages.ZeroPrice &&
        data.price.toString() !== '--'
      ) {
        totalPrice = totalPrice + data.price
      } else if (
        data.price.toString() === SpecificationMessages.quote ||
        data.price === SpecificationMessages.ZeroPrice
      ) {
        setPrice(intl.formatMessage(messages._PC_QUOTE_ITEM))
        isPriceValid = false
      } else {
        setPrice('--')
        isPriceValid = false
      }
    })

    if (isPriceValid) {
      const formattedPrice = priceFormatter(
        totalPrice,
        currencyFormat,
        thousandSeparator,
        thousandSpacing,
        decimalSeparator,
        prefixCurrecny,
        priceCallResponse.shrnaResult[0]?.currencySymbol
      )
      setPrice(formattedPrice)
    }
  }

  React.useEffect(() => {
    calculatePrice()
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceCallResponse, props.onDelete])

  //configuring the Configurator product data for sending it to GA

  const itemName = ProductNames['shrna']
  const configProductDetails: SemiConfigDetailsForGA =
    getSemiConfiguratorGAdata(
      state.priceCallResponse.shrnaResult,
      itemName,
      locale,
      props.currencyFormat,
      true
    )

  const handleAddToCart = async (): Promise<void> => {
    await shrnaAddToCart({
      variables: { input: state.shrnaAddtoCartData },
      fetchPolicy: 'no-cache',
    })
  }

  const getKey = (key) => {
    const data = getPhysicalMaterialKey.filter((item) => item.key === key)
    return data[0].value
  }

  React.useEffect(() => {
    if (data) {
      const errorMessage = ConfiguratorValues.AddToCartFail
      if (data?.shrnaAddToCart?.serverError) {
        //GAtracking event on button click of addToCart
        handleGAAddToCartErrorsForConfigurator(
          configProductDetails,
          errorMessage
        )
        props.updateError(ConfiguratorValues.AddToCartFail)
      } else {
        if (data?.shrnaAddToCart?.result === SemiConfigProperties.Success) {
          //GAtracking event on button click of addToCart
          handleGAAddToCartForConfigurator(configProductDetails)
          setTotalPrice(price)
          setTotalItem(priceCallResponse.shrnaResult.length)
          setDialogOpen(true)
        } else if (
          data?.shrnaAddToCart?.result === ErrorMessage.AccessTokenExpire
        ) {
          router.push(loginRoute.index())
          setGlobalSnackbarState({
            open: true,
            message: (
              <FormattedMessage
                {...messages.USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED}
              />
            ),
            variant: SnackbarType.Error,
          })
        } else {
          handleGAAddToCartErrorsForConfigurator(
            configProductDetails,
            errorMessage
          )
          props.updateError(ConfiguratorValues.AddToCartFail)
        }
      }
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <div className={classes.contentWrapper}>
      <Grid container>
        <Grid item sm={5}>
          <Grid className={classes.head}>
            <FormattedMessage {...messages.CONF_SPECIFICATIONS_crisprgrna} />
          </Grid>
          <Divider className={classes.dividerHor} />
          {state.priceCallData.physicalFormat.physicalMaterial ===
          SpecificationMessages.GLYCEROL ? (
            <>
              <Grid container className={classes.orderContainer}>
                <Grid item sm={5} className={classes.shipping}>
                  <Grid className={classes.physicalContainer}>
                    {
                      <FormattedMessage
                        {...messages.CONF_SPECIFICATION_PHYSICAL_MATERIAL}
                      />
                    }
                    :
                  </Grid>
                </Grid>
                <Grid item sm={7}>
                  <Grid className={classes.physicalContainer}>
                    {state.specificationValues.physicalMaterial}
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : state.priceCallData.physicalFormat.physicalMaterial ===
            SpecificationMessages.DNA ? (
            <>
              <Grid container className={classes.orderContainer}>
                <Grid item sm={5} className={classes.shipping}>
                  <Grid className={classes.physicalContainer}>
                    {
                      <FormattedMessage
                        {...messages.CONF_SPECIFICATION_PHYSICAL_MATERIAL}
                      />
                    }
                    :
                  </Grid>
                </Grid>
                <Grid item sm={7}>
                  <Grid className={classes.physicalContainer}>
                    {state.specificationValues.physicalMaterial}
                  </Grid>
                </Grid>
                <Grid item sm={5} className={classes.shipping}>
                  <Grid className={classes.physicalContainer}>
                    {
                      <FormattedMessage
                        {...messages.CONF_DNA_SPECIFICATION_crispgrna}
                      />
                    }
                    :
                  </Grid>
                </Grid>
                <Grid item sm={7}>
                  <Grid className={classes.physicalContainer}>
                    <Grid>{getKey(state.specificationValues.vector)}</Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : state.priceCallData.physicalFormat.physicalMaterial ===
            SpecificationMessages.VIRUS ? (
            <>
              <Grid container className={classes.orderContainer}>
                <Grid item sm={5} className={classes.shipping}>
                  <Grid className={classes.physicalContainer}>
                    {
                      <FormattedMessage
                        {...messages.CONF_SPECIFICATION_PHYSICAL_MATERIAL}
                      />
                    }
                    :
                  </Grid>
                </Grid>
                <Grid item sm={7}>
                  <Grid className={classes.physicalContainer}>
                    {state.specificationValues.physicalMaterial}
                  </Grid>
                </Grid>
                <Grid item sm={5} className={classes.shipping}>
                  <Grid>
                    {
                      <FormattedMessage
                        {...messages.CONF_DNA_SPECIFICATION_crispgrna}
                      />
                    }
                    :
                  </Grid>
                </Grid>
                <Grid item sm={7}>
                  <Grid>
                    <Grid>{getKey(state.specificationValues.vector)}</Grid>
                  </Grid>
                </Grid>
                <Grid item sm={5} className={classes.shipping}>
                  <Grid className={classes.physicalContainer}>
                    {
                      <FormattedMessage
                        {...messages.SEMICONF_VIRAL_TITER_crisprgrna}
                      />
                    }
                  </Grid>
                </Grid>
                <Grid item sm={7}>
                  <Grid className={classes.physicalContainer}>
                    <Grid>{state.specificationValues.titer}</Grid>
                  </Grid>
                </Grid>
                <Grid item sm={5} className={classes.shipping}>
                  <Grid className={classes.physicalContainer}>
                    {
                      <FormattedMessage
                        {...messages.CONF_VIRUS_VOLUME_SPECIFICATION_crispgrna}
                      />
                    }
                    :
                  </Grid>
                </Grid>
                <Grid item sm={7}>
                  <Grid className={classes.physicalContainer}>
                    <Grid>{state.specificationValues.volume}</Grid>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : (
            ''
          )}
        </Grid>

        <Grid item sm="auto">
          {' '}
          <Divider
            variant="middle"
            orientation="vertical"
            className={classes.divider}
          />
        </Grid>

        <Grid item sm={6} className={classes.leftPadding}>
          <Grid className={classes.head}>
            {<FormattedMessage {...messages.CART_SUMMARY} />}
          </Grid>
          <Divider className={classes.dividerHor} />
          <Grid container>
            <Grid item sm={3} className={classes.subHead}>
              {' '}
              {
                <FormattedMessage
                  id="CART_SUBTOTAL"
                  defaultMessage="Subtotal"
                />
              }
              :
            </Grid>
            <Grid item sm={9} className={classes.subHeadPrice}>
              {price}
            </Grid>
          </Grid>
          <Grid container className={classes.shippingbody}>
            <Grid item sm="auto" className={globalClasses.shippingfontWeight}>
              {' '}
              {
                <FormattedMessage
                  id="CART_SHIPPING"
                  defaultMessage="Shipping"
                />
              }
              :{' '}
            </Grid>{' '}
            <Grid className={globalClasses.ambientPadding}>
              {<FormattedMessage {...messages.SEMICONF_DRY_ICE_crispr} />}
            </Grid>
          </Grid>
          <Grid container direction="row" className={classes.list} spacing={2}>
            {price === intl.formatMessage(messages._PC_QUOTE_ITEM) ? (
              <Grid item sm={12} className={classes.fontQuote}>
                <FormattedMessage {...messages.CART_QUOTATION_TEXT} />{' '}
              </Grid>
            ) : (
              <>
                <Grid item sm={1} className={classes.note}>
                  {
                    <FormattedMessage
                      id="CART_ITEM_NOTE"
                      defaultMessage="Note"
                    />
                  }
                  :
                </Grid>
                <Grid item sm={11} className={classes.subTotal}>
                  {<FormattedMessage {...messages.CONF_PRICE_SUB_TOTAL} />}
                </Grid>
              </>
            )}
            <Grid container spacing={3}>
              <Grid className={classes.listPadding}>
                <ul>
                  <li className={classes.subListPadding}>
                    {
                      <FormattedMessage
                        {...messages.CONF_APPLICATIONFREIGHT_TAX}
                      />
                    }
                  </li>
                  <li className={classes.subListPadding}>
                    {<FormattedMessage {...messages.CONF_PROMOTIONAL_CODES} />}
                  </li>
                  {state.shrnaDropDownValue.physicalMaterial ===
                  SpecificationMessages.GLYCEROL ? (
                    <li className={globalClasses.summaryDescPadding}>
                      {
                        <FormattedMessage
                          {...messages.SEMI_CONF_SHIPPING_HOURS}
                        />
                      }
                    </li>
                  ) : state.shrnaDropDownValue.physicalMaterial ===
                    SpecificationMessages.DNA ? (
                    <li className={globalClasses.summaryDescPadding}>
                      {
                        <FormattedMessage
                          {...messages.SEMI_CONF_SHIPPING_HOURS_DNA}
                        />
                      }
                    </li>
                  ) : state.shrnaDropDownValue.physicalMaterial ===
                    SpecificationMessages.VIRUS ? (
                    <li className={globalClasses.summaryDescPadding}>
                      {
                        <FormattedMessage
                          {...messages.SEMI_CONF_SHIPPING_HOURS_VIRUS}
                        />
                      }
                    </li>
                  ) : (
                    ''
                  )}
                </ul>
              </Grid>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item sm={12}>
              <Button
                className={classes.button}
                color="primary"
                variant="contained"
                size="medium"
                onClick={handleAddToCart}
              >
                {
                  <FormattedMessage
                    id="ADD_TO_CART"
                    defaultMessage="Add to Cart"
                  />
                }
              </Button>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item sm={6}>
              <AddToCartItems
                dialogOpen={dialogOpen}
                setDialogOpen={setDialogOpen}
                price={totalPrice}
                totalItem={totalItem}
                companionProducts={null}
                productType={ActiveLinkType.ProductName}
                urlProduct={Url.SequenceUrl}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {loading && <CircleLoader />}
    </div>
  )
}

export default Summary
